import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/layout.css";
import logo from "../../../UC transparent logo.png";
import { AuthContext } from "../../../context/AuthContext";

const MainNavbar = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const accessLevel = localStorage.getItem("accessLevel");
  const isEnterprise = localStorage.getItem("isEnterprise") === "yes";
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [exploreTourOpen, setExploreTourOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState("");

  const closeMenu = () => {
    setMenuOpen(false);
    setUserMenuOpen(false);
    setExploreTourOpen(false);
  };

  // ✅ Logout
  const handleLogout = () => {
    closeMenu();
    logout();
    window.location.href = "/2.0";
  };

  // ✅ Resize handler
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
        setUserMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleTourMenu = () => {
      setMenuOpen(true);
      setUserMenuOpen(false);
    };

    window.addEventListener("udyog2-open-tour-menu", handleTourMenu);
    return () => window.removeEventListener("udyog2-open-tour-menu", handleTourMenu);
  }, []);

  useEffect(() => {
    const handleTourExplore = () => setExploreTourOpen(true);
    const handleCloseTourExplore = () => setExploreTourOpen(false);

    window.addEventListener("udyog2-open-tour-explore", handleTourExplore);
    window.addEventListener("udyog2-close-tour-explore", handleCloseTourExplore);
    return () => {
      window.removeEventListener("udyog2-open-tour-explore", handleTourExplore);
      window.removeEventListener("udyog2-close-tour-explore", handleCloseTourExplore);
    };
  }, []);

  // ✅ Fetch profile photo
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/profile/get`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => res.json())
        .then((data) => setProfilePhoto(data.profile_photo))
        .catch(() => {});
    }
  }, []);

  // ✅ Protected Link Component
  const ProtectedLink = ({ to, label, tourId }) => {
    const handleClick = (e) => {
      if (!isAuthenticated) {
        e.preventDefault();
        navigate("/2.0/login", { state: { from: to } });
      } else {
        closeMenu();
      }
    };

    return (
      <div className="protected-link-wrapper">
        <Link
          to={isAuthenticated ? to : "#"}
          onClick={handleClick}
          className={!isAuthenticated ? "disabled-link" : ""}
          data-tour={tourId}
        >
          {label}
        </Link>

        {!isAuthenticated && (
          <span className="protected-tooltip">
            Login / Signup to access
          </span>
        )}
      </div>
    );
  };

  if (isAuthenticated && isEnterprise) {
    return (
      <div className="main-navbar">
        <div className="navbar-row">
          <div className="left-section">
            <div className="logo-section">
              <img
                src={logo}
                alt="Udyog Connect Logo"
                onClick={() => navigate("/2.0")}
                className="logo-img"
              />
              <div
                className="logo-text"
                onClick={() => navigate("/2.0")}
              >
                UDYOG Connect 2.0
              </div>
            </div>

            <div className={`navbar-content ${menuOpen ? "open" : ""}`}>
              <div className="nav-links">
                <Link to="/2.0/udyogconnect-home" onClick={closeMenu} data-tour="nav-home">
                  Home
                </Link>
                <Link to="/2.0/about" onClick={closeMenu} data-tour="nav-about">
                  About
                </Link>
                <ProtectedLink to="/2.0/enterprise-management" label="Enterprise Management" tourId="nav-enterprise" />
              </div>

              <div className="auth-buttons mobile-auth">
                <Link to="/2.0/updatepassword" onClick={closeMenu} data-tour="nav-password">
                  Password Update
                </Link>
                <button className="login-btn" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          </div>

          <div className="right-section">
            <div className="auth-buttons desktop-auth">
              <div className="profile-menu">
                <img
                  src={
                    profilePhoto ||
                    "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  }
                  alt="profile"
                  className="profile-icon"
                  data-tour="nav-profile"
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                />

                {userMenuOpen && (
                  <div className="profile-dropdown">
                    <Link to="/2.0/updatepassword" onClick={closeMenu}>
                      Password Update
                    </Link>
                    <div className="logout-btn" onClick={handleLogout}>
                      Logout
                    </div>
                  </div>
                )}
              </div>
            </div>

            <button
              className="menu-toggle"
              data-tour="nav-menu"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              Menu
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-navbar">
      <div className="navbar-row">
        {/* LEFT SECTION */}
        <div className="left-section">
          <div className="logo-section">
            <img
              src={logo}
              alt="Udyog Connect Logo"
              onClick={() => navigate("/2.0")}
              className="logo-img"
            />
            <div
              className="logo-text"
              onClick={() => navigate("/2.0")}
            >
              UDYOG Connect 2.0
            </div>
          </div>

          <div className={`navbar-content ${menuOpen ? "open" : ""}`}>
            <div className="nav-links">
              <Link to="/2.0/udyogconnect-home" label="Home" onClick={closeMenu} data-tour="nav-home">Home</Link>
                  <Link to="/2.0/consumer-onboarding" onClick={closeMenu} data-tour="nav-enterprise-onboarding">
                    Enterprise Onboarding
                  </Link>
                  <Link to="/2.0/about" onClick={closeMenu} data-tour="nav-about">
                    About
                  </Link>
                  <Link to="/2.0/partnership-programs" onClick={closeMenu} data-tour="nav-training">
                    Training Programs
                  </Link>
              <Link to="/2.0/about-partnership" onClick={closeMenu} data-tour="nav-partners">
                Our Partners
              </Link>
              <Link to="/2.0/calendar" onClick={closeMenu} data-tour="nav-calendar">
                Calendar
              </Link>

              <ProtectedLink to="/2.0/opportunities" label="Opportunities" tourId="nav-opportunities" />
              <ProtectedLink to="/2.0/request" label="Need Help?" tourId="nav-request" />
              {isEnterprise && (
                <ProtectedLink to="/2.0/enterprise-management" label="Enterprise Management" tourId="nav-enterprise" />
              )}

              {/* EXPLORE MENU */}
              <div className={`explore-menu ${exploreTourOpen ? "tour-open" : ""}`}>
                <span className="explore-title" data-tour="nav-explore">Explore ▾</span>
                <div className="explore-dropdown">
                  <ProtectedLink to="/2.0/companies" label="Industry Presence" tourId="nav-companies" />
                  <Link to="/uc/panditpurshothit" onClick={closeMenu} data-tour="nav-divine-rituals">
                    Divine Rituals
                  </Link>
                  <ProtectedLink
                    to="/2.0/claude-practice-test"
                    label="UC Claude Practice Test"
                    tourId="nav-claude-practice-test"
                  />
                </div>
              </div>

              {accessLevel === "admin" && (
                <ProtectedLink to="/2.0/admin" label="Admin" tourId="nav-admin" />
              )}
            </div>

            {/* MOBILE AUTH */}
            <div className="auth-buttons mobile-auth">
              {!isAuthenticated ? (
                <button
                  className="login-btn"
                  onClick={() => {
                    closeMenu();
                    navigate("/2.0/login");
                  }}
                >
                  LOGIN / SIGNUP
                </button>
              ) : (
                <>
                  <Link to="/2.0/profile-update" onClick={closeMenu} data-tour="nav-profile-update">
                    Profile Update
                  </Link>
                  <Link to="/2.0/my-registrations" onClick={closeMenu}>
                    My registrations
                  </Link>
                  <Link to="/2.0/updatepassword" onClick={closeMenu} data-tour="nav-password">
                    Password Update
                  </Link>
                  <button className="login-btn" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="right-section">
          <div className="auth-buttons desktop-auth">
            {!isAuthenticated ? (
              <button
                className="login-btn"
                data-tour="nav-login"
                onClick={() => {
                  closeMenu();
                  navigate("/2.0/login");
                }}
              >
                LOGIN / SIGNUP
              </button>
            ) : (
              <div className="profile-menu">
                <img
                  src={
                    profilePhoto ||
                    "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  }
                  alt="profile"
                  className="profile-icon"
                  data-tour="nav-profile"
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                />

                {userMenuOpen && (
                  <div className="profile-dropdown">
                    <Link to="/2.0/profile-update" onClick={closeMenu}>
                      Profile Update
                    </Link>
                    <Link to="/2.0/my-registrations" onClick={closeMenu}>
                      My registrations
                    </Link>
                    <Link to="/2.0/updatepassword" onClick={closeMenu}>
                      Password Update
                    </Link>
                    <div className="logout-btn" onClick={handleLogout}>
                      Logout
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <button
            className="menu-toggle"
            data-tour="nav-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainNavbar;
